module.exports = __webpack_public_path__ + "img/hdx_img.033fe54d.jpg";